import { Loader } from "@app/components/core/Loader/Loader"
import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation, useNavigationData } from "@app/components/navigation/NavigationHandler"
import { useGetPlanningObject } from "@app/store/service/connectorService"
import { classNamez } from "@tecreation/funnel-components"
import { useEffect, useMemo, useState } from "react"
import { TabletSaunaBoatBase } from "../TabletSaunaBoatBase"

export default function TableSaunaBooking1() {
	const { data: objects, isFetching, refetch } = useGetPlanningObject({ date: new Date().toISOString().slice(0, 10) })
	const { push } = useCustomNavigation()

	const navData = useNavigationData()
	const [option, setOption] = useState(navData?.option)

	const filteredObjects = useMemo(() => {
		const currentTime = new Date()
		if (!objects) return []

		const now = currentTime.getTime()
		const result = objects.filter(o => {
			const hours = o.timeFrom.slice(0, 2)
			const minutes = o.timeFrom.slice(3, 5)
			currentTime.setHours(parseInt(hours), parseInt(minutes), 0)
			return currentTime.getTime() > now
		})
		return result
	}, [objects])

	useEffect(() => {
		refetch()
		let timer = setInterval(() => {
			refetch()
		}, 10000)

		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<TabletSaunaBoatBase>
			<div className="f3">Buchen Sie sich hier einen kostenfreien Platz für eine Panoramafahrt (mit Aufguss) in unserem einzigartigen Saunaboot Freya.</div>
			<div className="f4 mt-4">Zu welcher Uhrzeit möchten Sie Plätze im Saunaboot reservieren?</div>
			<Loader show={isFetching} />

			<div className="flex mt-5">
				{filteredObjects && (filteredObjects.length === 0 || filteredObjects.reduce((count, next) => count + next.restCount, 0) <= 0) && (
					<div className="color-fg-danger semibold">Für den heutigen Tag sind keine freien Kapazitäten verfügbar ☹</div>
				)}
				{filteredObjects &&
					filteredObjects.map(entry => {
						if (entry.restCount <= 0) return

						return (
							<div
								key={entry.timeSlotId}
								className={
									"border rounded-3 py-2 px-4 mr-4 text-center" +
									classNamez({
										"color-bg-primary": entry.timeSlotId === option?.timeSlotId,
										"color-fg-white": entry.timeSlotId === option?.timeSlotId,
									})
								}
								onClick={() => {
									if (entry.timeSlotId === option?.timeSlotId) {
										setOption(undefined)
									} else {
										setOption(entry)
									}
								}}
							>
								<div>{entry.timeFrom.slice(0, 5)}</div>
								<div>Plätze: {entry.restCount}</div>
							</div>
						)
					})}
			</div>
			<div className="mt-auto flex">
				<Button
					style="secondary"
					className="ml-auto"
					disabled={!option}
					onClick={() => {
						push("/tablet-sauna-boat-2", undefined, { option })
					}}
				>
					Weiter
				</Button>
			</div>
		</TabletSaunaBoatBase>
	)
}
